import { render, staticRenderFns } from "./CustomExport.vue?vue&type=template&id=6a054fa2&scoped=true"
import script from "./CustomExport.vue?vue&type=script&lang=js"
export * from "./CustomExport.vue?vue&type=script&lang=js"
import style0 from "./CustomExport.vue?vue&type=style&index=0&id=6a054fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a054fa2",
  null
  
)

export default component.exports